import { useEffect, useState } from "react";
import { Caracteristicas } from "../../../interfaces/Caracteristicas";
import { CaracteristicasApto } from "../../../interfaces/CaracteristicasApto";
import { buscarCaracteristicasService } from "../../../services/buscarCaracteristicasService";

export const useBuscarCaracteristicas = (
  isModalOpen: boolean,
  aptoId: number | null
) => {
  const [caracteristicas, setCaracteristicas] = useState<Caracteristicas[]>([]);
  const [caracteristicasApto, setCaracteristicasApto] = useState<
    CaracteristicasApto[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const buscar = async () => {
      setIsLoading(true);
      const data = await buscarCaracteristicasService("APARTAMENTO", aptoId);
      setCaracteristicas(data.caracteristicas || []);
      setCaracteristicasApto((data.vinculadas as CaracteristicasApto[]) || []);
      setIsLoading(false);
    };

    if (isModalOpen && aptoId) {
      buscar();
    } else {
      setCaracteristicas([]);
      setCaracteristicasApto([]);
      setIsLoading(false);
    }
  }, [isModalOpen, aptoId]);

  return { caracteristicas, caracteristicasApto, isLoading };
};
